import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Accordion, Grid, Header, Icon, Image, Label, Message, Segment } from "semantic-ui-react";
import styles from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/spiritual/";
const iconRoute = process.env.REACT_APP_CDN_ROUTE + "/icons/";

const SpiritualNeedsLearnMore: React.FC = () => {
  const [activeAccordionIndexes] = useState([0,1]);

  const renderAccordionTips = () => {
    return (
      <>  
      <Segment raised className={styles.learnMoreOverviewTextBox} >
        <p className={styles.learnMoreAccordionText} > 
          <span className={styles.learnMoreAccordionTextEmphasis} > Communities of faith are in excellent positions to help 
            families plan for the care of their older members. </span> Many people are strong believers in God and attend 
            religious services and events regularly. </p>   
        <p className={styles.learnMoreAccordionText} > 
        They are more likely to rely on their own faith and on advice from their clergy in addressing family problems than 
        they are to rely on social service or other community agencies. </p>
      </Segment>  
      <Grid stackable className={styles.learnMoreFullDiv} >
        <Grid.Row stretched columns='equal' className={styles.highlightsItemRow} >
          <Grid.Column stretched container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle} `}>
            <Segment raised className={styles.highlightsItemWhiteBG} >  
              <Header as='h2' icon className={styles.highlightsItemHeader} >
                <Image src={`${iconRoute}Support2Icon.png`} className={styles.highlightsItemHeaderImgIcon} />  
                  FIRST STEPS
                <Header.Subheader> 
                  <p className={styles.learnMoreAccordionText} >
                    The most important first step in helping promote the older adult's spiritual and emotional well-being is 
                    to understand their beliefs, wants, and needs.</p>
                  <p className={styles.learnMoreAccordionText} >
                    Even if we share the same faith community, it is possible that we are out of touch with the older 
                    adult's core beliefs and concerns which are often profoundly influenced by the difficulties of late life.</p>
                </Header.Subheader>
              </Header>
            </Segment>  
          </Grid.Column>
          <Grid.Column width={8} className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle} `}>
            <Segment raised className={styles.highlightsItemWhiteBG} >  
              <Header as='h2' icon className={styles.highlightsItemHeader} >
                <Image src={`${iconRoute}ListenIcon.png`} className={styles.highlightsItemHeaderImgIcon} />  
                  APPROACHING THE CONVERSATION
                <Header.Subheader>  
                  <p className={styles.learnMoreAccordionText} >
                    Take time to have a focused, non-judgmental conversation with the older adult, in which you are the attentive 
                    listener. Focus on hearing their perspectives on what they think you can do to help them meet their emotional 
                    and spiritual needs. </p>
                  <p className={styles.learnMoreAccordionText} >
                    With a clear understanding of what the older adult wants for the months and years ahead, you can prepare 
                    together to take specific steps to achieve their goals.</p>
                </Header.Subheader>
              </Header>
            </Segment>  
          </Grid.Column>
        </Grid.Row>
      </Grid>
      </>
    );
  };

  const accordions = [
    { key: 'tips',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} > How Spiritual Beliefs Can Help </Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionTips()}/>)
      }
    }
  ];
  
  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}SpiritualNeedsInfoOne.jpg)`, }}>
        <div className={styles.learnMoreModalContent}>

          <div className={styles.learnMoreAccordionFullDivGrid} >
            <div className={styles.learnMoreAccordionFullDiv} >
              <Accordion panels={accordions} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionIndexes} exclusive={false} />
            </div> 
          </div>  

        </div>
      </Segment>      
    </>
  );   
};

export default observer(SpiritualNeedsLearnMore);
